const en_US = {
    //'Type': 'Type',
    //'RealTimeType' : 'RealTimeType'
    "Enter Confined Space Work Permit": "Confined Space Work Permit",
    "Work Site": "Work Site",
    "Work Content": "Work Content",
    "Contractor/Owner": "Contractor/Owner",
    "Approved Qualified Person": "Approved Qualified Person",
    "Risk Assessment Report Date and Time": "Risk Assessment Report Date and Time",
    "Entry Date": "Entry Date",
    "Validity Period Until (Date)": "Validity Period Until (Date)",
    "Time": "Time",
    "Approved Workers": "Approved Workers",
    "Maximum Stay Time for Approved Workers (Hours)": "Maximum Stay Time for Approved Workers (Hours)",
    "Add Worker": "Add Worker",
    "Name": "Name",
    "ID Number": "ID Number",
    "ID Expiry Date": "ID Expiry Date",
    "Worker Signature": "Worker Signature",
    "Actions": "Actions",
    "Save": "Save",
    "Clear": "Clear",
    "Delete": "Delete",
    "Standby Workers": "Standby Workers",
    "Add Standby Worker": "Add Standby Worker",
    "Training Date": "Training Date",
    "Duty": "Duty",
    "Rescue Workers on Site": "Rescue Workers on Site",
    "Add Rescue Worker": "Add Rescue Worker",
    "Emergency Rescue Training Date": "Emergency Rescue Training Date",
    "Ground Pipe Work": "Ground Pipe Work",
    "This confined space work is subject to Section 9(b) of the Factory and Industrial Operations (Confined Spaces) Regulations, which refers to ground pipe work. Therefore, the contractor/owner must": "This confined space work is subject to Section 9(b) of the Factory and Industrial Operations (Confined Spaces) Regulations, which refers to ground pipe work. Therefore, the contractor/owner must",
    "ensure that any person entering the confined space or remaining in it is properly equipped with appropriate respiratory equipment; and": "ensure that any person entering the confined space or remaining in it is properly equipped with appropriate respiratory equipment; and",
    "use appropriate monitoring equipment (designed for explosion-proof) to continuously monitor the gas in the confined space until all persons have left the confined space; and": "use appropriate monitoring equipment (designed for explosion-proof) to continuously monitor the gas in the confined space until all persons have left the confined space; and",
    "This confined space work is not subject to Section 9(b) of the Factory and Industrial Operations (Confined Spaces) Regulations, for the following reasons:": "This confined space work is not subject to Section 9(b) of the Factory and Industrial Operations (Confined Spaces) Regulations, for the following reasons:",
    "Reason": "Reason",
    "Note: The above options must be mutually exclusive.": "Note: The above options must be mutually exclusive.",
    "Isolation Measures": "Isolation Measures",
    "Measure": "Measure",
    "Signature": "Signature",
    "Date and Time": "Date and Time",
    "Cleaning and Ventilation Control Measures": "Cleaning and Ventilation Control Measures",
    "Air Testing": "Air Testing",
    "Add Air Test": "Add Air Test",
    "Test Date": "Test Date",
    "Air Monitoring Equipment Model": "Air Monitoring Equipment Model",
    "Air Monitoring Equipment Serial Number": "Air Monitoring Equipment Serial Number",
    "Air Monitoring Equipment Calibration Validity Until": "Air Monitoring Equipment Calibration Validity Until",
    "Test Location": "Test Location",
    "Test Time": "Test Time",
    "Oxygen": "Oxygen",
    "Lower Limit (Percentage)": "Lower Limit (Percentage)",
    "Hydrogen Sulphide (ppm)": "Hydrogen Sulphide (ppm)",
    "Carbon Monoxide (ppm)": "Carbon Monoxide (ppm)",
    "Responsible Person for Air Testing": "Responsible Person for Air Testing",
    "Responsible Person Signature": "Responsible Person Signature",
    "Delete This Test": "Delete This Test",
    "Remove Location": "Remove Location",
    "Add Test Location": "Add Test Location",
    "□ I hereby confirm that I have tested the air in this confined space and found no hazardous gases and no oxygen deficiency.": "□ I hereby confirm that I have tested the air in this confined space and found no hazardous gases and no oxygen deficiency.",
    "Safety Measures Required for Entry into Confined Spaces": "Safety Measures Required for Entry into Confined Spaces",
    "Emergency Rescue Equipment Provided": "Emergency Rescue Equipment Provided",
    "Quantity/Number": "Quantity/Number",
    "Description": "Description",
    "Tripod and Crane": "Tripod and Crane",
    "Other": "Other",
    "I hereby confirm that the emergency rescue equipment provided is sufficient and in satisfactory condition, and is readily available at all times.": "I hereby confirm that the emergency rescue equipment provided is sufficient and in satisfactory condition, and is readily available at all times.",
    "List of Protective Equipment Provided": "List of Protective Equipment Provided",
    "Piece": "Piece",
    "Clothing": "Clothing",
    "Declarations by Owner/Contractor or Authorized Representative": "Declarations by Owner/Contractor or Authorized Representative",
    "Valid Date": "Valid Date",
    "Position": "Position",
    "Cancel": "Cancel",
    "Stakeholder Type": "Stakeholder Type",
    "Owner": "Owner",
    "Contractor": "Contractor",
    "Authorized Representative": "Authorized Representative",
    "Edit Work Permit": "Edit Work Permit",
    "Create Work Permit": "Create Work Permit",
    "Loading Work Permit Data...": "Loading Work Permit Data...",
    "Edit Risk Assessment": "Edit Risk Assessment",
    "Add Risk Assessment": "Add Risk Assessment",
    "Please Create Work Schedule First": "Please Create Work Schedule First",
          "WorkPermitCertificate": "Work Permit Certificate",
      "ApprovedWorkPermitCertificate": "Approved Work Permit Certificate",
      "CompletionCertificate": "Completion Certificate",
      "CancelledWorkPermitCertificate": "Cancelled Work Permit Certificate",
      "View Work Permit": "View Work Permit",
      "Close": "Close",
      // Risk Assessment
      "Risk Assessment": "Risk Assessment",
      "Create Risk Assessment": "Create Risk Assessment",
      "View Risk Assessment": "View Risk Assessment",
      "Loading Risk Assessment Data...": "Loading Risk Assessment Data...",
      "Workplace": "Workplace",
      "Subcontractor (if applicable)": "Subcontractor (if applicable)",
      "Competent Person Name": "Competent Person Name",
      "Competent Person Signature": "Competent Person Signature",
      "Basic Information": "Basic Information",
      "Competent Person Information": "Competent Person Information",
      "No.": "No.",
      "Assessment Items": "Assessment Items",
      "Assessment Results": "Assessment Results",
      "Required Safety Precautions": "Required Safety Precautions",
      "Severity of Consequence": "Severity of Consequence",
      "Likelihood of Incident": "Likelihood of Incident",
      "Risk Rating": "Risk Rating",
      "Very Severe (3)": "Very Severe (3)",
      "Severe (2)": "Severe (2)",
      "Minor (1)": "Minor (1)",
      "Very Likely (3)": "Very Likely (3)",
      "Likely (2)": "Likely (2)",
      "Unlikely (1)": "Unlikely (1)",
      "High Risk (>=6)": "High Risk (>=6)",
      "Medium Risk (3-5)": "Medium Risk (3-5)",
      "Low Risk (<=2)": "Low Risk (<=2)",
      "Hours": "Hours",
      "Risk Rating Table Reference": "For definitions of 'Severity of Consequence', 'Likelihood of Incident', and 'Risk Rating', please refer to the risk rating table at the end of this assessment form.",
      "Equipment Checklist": "Equipment Checklist:",
      "Risk Assessment Content": "Risk Assessment Content",
      "Certificate Expiry Date": "Certificate Expiry Date",
      "Download PDF": "Download PDF",
}

export default en_US;